import React, {useContext, useEffect} from "react";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {getEditPermission} from "../Apollo_Authorization";
import {ApolloContext} from "../Apollo_Context";
import TargetTime from "./Apollo_TargetTime";

type ScheduleProps = {
  schedule: boolean[][],
  setSchedule: any,
  weekLyType?: number,
}

export const ApolloCampaignSchedule = ({schedule, setSchedule, weekLyType}: ScheduleProps) => {
  const {state} = useContext(ApolloContext);
  const isEditor = getEditPermission(state);
  const weekLyLabelType = weekLyType? weekLyType: 1;
  return (
    <React.Fragment>
      <Typography variant="subtitle1" gutterBottom component="div">
        掲載スケジュール
      </Typography>
      <Paper style={{overflow: 'auto'}} square variant="outlined">
        <TargetTime
          key={schedule.length === 0 ? "Loaded" : "Loading"}
          week={schedule}
          disabled={!isEditor}
          onChange={(week: any) => setSchedule(week)}
          weekLyLabelType={weekLyLabelType}
        />
      </Paper>
    </React.Fragment>
  );
}

export const getDefaultSchedule = function (): boolean[][] {
  // scheduleの初期化用定数
  const DEFAULT_ACTIVE_HOUR = true;
  const DEFAULT_HOURS = new Array(24).fill(DEFAULT_ACTIVE_HOUR);
  return new Array(7).fill(DEFAULT_HOURS);
}

export const scheduleArrayToString = function (scheduleArray: boolean[][]) {
  const scheduleArrayNumber = scheduleArray.map(row => {
    return row.map(value => value === true ? 1 : 0)
  })
  const scheduleStringNumber = JSON.stringify(scheduleArrayNumber)
  return scheduleStringNumber
}

export const scheduleStringToArray = function (scheduleString: string) {
  const scheduleArray = JSON.parse(scheduleString)
  const scheduleArrayBoolean = scheduleArray.map((row: any) => {
    return row.map((value: number) => value === 1 ? true : false)
  })
  return scheduleArrayBoolean
}

export const formatShSchedule = function (schedule: boolean[][]): string {
  const scheduleArrayNumber = schedule.map(row => {
    return row.map(value => value === true ? 1 : 0);
  });
  return scheduleArrayNumber.map(row => {
    return row.join("");
  }).join("");
}



